export const professionRealmMapping = [
    { realm: "channel", professionId: 0, attributes: ["in"] },
    { realm: "mental", professionId: 2, attributes: ["ch"] },
    { realm: "channel/mental", professionId: 6, attributes: ["in", "ch"] },
    { realm: "essence/channel", professionId: 7, attributes: ["em", "in"] },
    { realm: "essence", professionId: 8, attributes: ["em"] },
    { realm: "channel", professionId: 9, attributes: ["in"] },
    { realm: "mental", professionId: 14, attributes: ["ch"] },
    { realm: "essence", professionId: 15, attributes: ["em"] },
    { realm: "mental", professionId: 16, attributes: ["ch"] },
    { realm: "essence", professionId: 17, attributes: ["em"] },
    { realm: "essence/mental", professionId: 18, attributes: ["em", "ch"] },
    { realm: "channel", professionId: 19, attributes: ["in"] },
    { realm: "essence", professionId: 21, attributes: ["em"] },
    { realm: "channel", professionId: 22, attributes: ["in"] },
    { realm: "mental", professionId: 23, attributes: ["ch"] },
    { realm: "channel", professionId: 24, attributes: ["in"] },
    { realm: "channel", professionId: 25, attributes: ["in"] },
    { realm: "channel", professionId: 26, attributes: ["in"] },
    { realm: "channel", professionId: 27, attributes: ["in"] }
];
export function getSpellListBySpellDevelopmentName(name, profession) {
    if ("Offene Liste" == name)
        return ["0", "7",];
    if ("Geschlossene Liste" == name)
        return ["1", "8", "15",];
}
export const spelllistIdMapping = {
    "Offene Liste": ["0", "7",],
    "Geschlossene Liste": ["1", "8", "15",],
    "Basislisten eigene": [],
    "Arkan offen": [],
    "Andere Basisliste": [],
    "Basislisten alle": [],
    "Fremder Bereich offen": [],
    "Fremder Bereich geschl": [],
    "Fremder Bereich Basis": [],
    "Eigener Bereich offen": [],
    "Eigener Bereich geschlossen": [],
    "Eigener Bereich fremde Basis": [],
    "Eigener Breich fremde Basis": []
};
